import { IApplicationState } from '../../types/redux';

export const mortgageSeoPageActiveSelector = (state: IApplicationState): boolean => {
  return state.seoPages.isMortgageSeoPageActive;
};
